<div class="auth-page" *ngIf="currentAuthPage">
  <p-dialog
    [(visible)]="displayDialog"
    [dismissableMask]="true"
    [modal]="true"
    [resizable]="false"
    [style]="{ width: '1400px' }"
    [responsive]="false"
    [showHeader]="false"
    (onHide)="closeAuthModal()"
  >
    <div class="card auth-card card--vertical card--default card--wrapped has__background">
      <div *ngIf="loginNormal()" class="card__bg card__bg--cloud-top hidden-xs"></div>

      <div *ngIf="loginNormal()" class="card__bg-wrapper">
        <div class="card__bg card__bg--planet-bg">
          <h1
            class="card__title card__title--lg"
            [ngClass]="{ 'hidden-xs': router.url.indexOf('resetting-password?token') > -1 }"
            [innerHTML]="layoutTitle"
          ></h1>
        </div>
        <ng-lottie [options]="options"></ng-lottie>
      </div>

      <div
        *ngIf="authFromHelpUkraine"
        class="card__bg-wrapper card__bg__ua"
        style="position: relative"
      >
        <h1
          class="card__title card__title--lg"
          [ngClass]="{ 'hidden-xs': router.url.indexOf('resetting-password?token') > -1 }"
          style="color: #18a0fb"
        >
          {{ 'HOMEPAGE.BANNERS_DESCRIPTIONS.banner_description_help_ukraine' | translate }}
        </h1>
        <img
          [src]="coverImage"
          alt=""
          style="
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
            width: 80%;
          "
        />
      </div>
      <div *ngIf="authWcd" class="card__bg-wrapper card__bg__ua" style="position: relative">
        <img [src]="coverImage" alt="" />
      </div>

      <div *ngIf="loginNormal()" class="card__bg card__bg--cloud-bottom hidden-xs"></div>
      <button class="card__close" (click)="closeAuthModal()">
        <i class="zmdi zmdi-close"></i>
      </button>
      <div class="card__body">
        <div class="form form--login">
          <app-login *ngIf="currentAuthPage === 'login'"></app-login>
          <app-register *ngIf="currentAuthPage === 'register'"></app-register>
          <app-register-company
            *ngIf="currentAuthPage === 'register-company'"
          ></app-register-company>
          <app-reset-pass *ngIf="currentAuthPage === 'reset-pass'"></app-reset-pass>
          <app-confirm-email *ngIf="currentAuthPage === 'confirm-email'"></app-confirm-email>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
